const MIME_ALIASES: Record<string, string> = {
  "image/jpg": "image/jpeg",
  "image/pjpeg": "image/jpeg",
  "image/x-png": "image/png",
  "image/x-heic": "image/heic",
  "image/heic-sequence": "image/heic",
  "image/x-heif": "image/heif",
  "image/heif-sequence": "image/heif",
  "video/x-m4v": "video/mp4",
  "audio/x-wav": "audio/wav",
  "audio/x-m4a": "audio/mp4",
};

const MIME_BY_EXTENSION: Record<string, string> = {
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  jpe: "image/jpeg",
  png: "image/png",
  gif: "image/gif",
  webp: "image/webp",
  avif: "image/avif",
  heic: "image/heic",
  heif: "image/heif",
  mp4: "video/mp4",
  m4v: "video/mp4",
  mov: "video/quicktime",
  webm: "video/webm",
  mp3: "audio/mpeg",
  wav: "audio/wav",
  m4a: "audio/mp4",
  flac: "audio/flac",
  oga: "audio/ogg",
  ogg: "audio/ogg",
  opus: "audio/ogg",
  weba: "audio/webm",
};

/** Browsers do not consistently report MIME for files selected from iOS/macOS. */
export function inferUploadMime(filename: string, reportedMime?: string): string {
  const reported = (reportedMime ?? "").split(";", 1)[0].trim().toLowerCase();
  const normalized = MIME_ALIASES[reported] ?? reported;
  if (normalized && normalized !== "application/octet-stream") return normalized;
  const extension = filename.toLowerCase().match(/\.([a-z0-9]+)$/)?.[1] ?? "";
  return MIME_BY_EXTENSION[extension] ?? normalized;
}

export function isHeicMime(mime: string): boolean {
  const normalized = MIME_ALIASES[mime.toLowerCase()] ?? mime.toLowerCase();
  return normalized === "image/heic" || normalized === "image/heif";
}
